/*
 * Oui Chef - Product Engraver  v1.9  2026 10 21
 * v1.9: a floating preview pill follows the customer down the page whenever the
 *       pill on the photo is out of view (and they're in the engraving area).
 *       On desktop the photo column also stays in view while scrolling (CSS).
 * v1.8: Copper, Gold and Blue pills re-shaded to the richer anodised colour of the Vito caps
 *       (sampled from the photos, highlights left out), light engraving text as before.
 * v1.7: the page opens on the selected colour's photo (with the pill) instead of the
 *       featured photo, which stays first for collection pages. Photos with a pill
 *       are moved up a little (data-photo-shift) so the needle clears the pill.
 * v1.6: when the customer starts typing or picks a font, the gallery jumps to the
 *       chosen colour's photo (the one with the pill) if another photo is showing.
 * v1.5: Chrome pill is a neutral mirror silver matching the theme's Chrome swatch
 *       (the Kit Builder's chrome looked blue-grey on the photos), with dark grey
 *       engraving text so it can be read on the light pill. Kit Builder unchanged.
 * v1.4: preview text a bit smaller overall; Tokio, DM Serif and Work Sans a good
 *       notch smaller again. Per-font 'width' and 'fill' below.
 * v1.3.1: finds the theme's product form itself. A Custom Liquid block can't see
 *       the theme's product_form_id, so it arrived empty: the quantity was never
 *       read (no extra boxes) and the Engraving/Font inputs weren't joined to the form.
 * v1.3: one name box per needle (follows the quantity selector); each different
 *       name becomes its own cart line. One font for all.
 * v1.2: text fills the pill by height as well as width (tall script fonts like
 *       Angello were too small), and script fonts may be stretched left to right
 *       (as on the laser) up to each font's 'stretch' limit below.
 * v1.1: the pill now sits on the theme's own product photos (Focal gallery),
 *       one pill on each variant's photo. No separate preview image.
 * ------------------------------------------------------------
 * One-line engraving text, 6 fonts and a live preview pill on the
 * variant image. Normal add to cart: the text and font are sent as
 * line item properties "Engraving" and "Font" on the theme's own
 * product form (inputs use form="..."), so Shopify, the cart, the
 * order and the packing slip all see them with no app.
 *
 * - Same 6 fonts + Focal font workarounds as the Kit/Team Builder
 *   (div role=radio, inline !important font styles).
 * - Pill colour follows the chosen variant, using the Kit/Team Builder
 *   banner gradients. Engraving text always light silver (#F0F0F0),
 *   same as the Kit Builder.
 * - Same word filter as the Team Builder (v0.2.3).
 * - Empty text = no engraving: the properties are disabled so nothing
 *   is added to the cart line.
 * - Ready for a later "Text OR Logo + symbol" option: the hidden
 *   _engraving_type property is "text" for now.
 */
(function () {
  'use strict';

  /* ---------------- COLOURS (Kit/Team Builder banner gradients) ---------------- */
  var COLOURS = [
    { key: 'black',  match: ['gloss black', 'black'], banner: 'linear-gradient(150deg, #484848 0%, #1a1a1a 35%, #080808 55%, #1a1a1a 75%, #282828 100%)' },
    // Chrome: neutral silver taken from the theme's Chrome swatch (not the Kit Builder's blue-grey). text/shadow: engraving colour on this pill.
    { key: 'chrome', match: ['chrome'],               banner: 'linear-gradient(to bottom, #b4b6ba 0%, #d6d8dc 28%, #f4f5f7 50%, #d6d8dc 72%, #bfc1c5 100%)',
      text: '#5f6267', shadow: '0 1px 0 rgba(255,255,255,.65)' },
    // v1.8: Copper / Gold / Blue: the richer anodised colour of the Vito caps (photo highlights left out)
    { key: 'copper', match: ['copper'],               banner: 'linear-gradient(to bottom, #6e4030 0%, #a0694f 25%, #c99079 48%, #a8705a 70%, #74432f 100%)' },
    { key: 'gold',   match: ['gold'],                 banner: 'linear-gradient(to bottom, #8a6a26 0%, #bf9a45 25%, #e2c77c 48%, #c4a04c 70%, #8f6e28 100%)' },
    { key: 'blue',   match: ['metallic blue', 'blue'], banner: 'linear-gradient(to bottom, #0f2a47 0%, #24507f 25%, #4f80b3 48%, #2a5888 70%, #11304f 100%)' }
  ];
  function colourFor(title) {
    var t = String(title || '').toLowerCase();
    for (var i = 0; i < COLOURS.length; i++) {
      for (var j = 0; j < COLOURS[i].match.length; j++) { if (t.indexOf(COLOURS[i].match[j]) >= 0) { return COLOURS[i]; } }
    }
    return COLOURS[0];
  }

  /* ---------------- FONTS (same six as Kit/Team Builder) ---------------- */
  // width: share of the pill width the text may use (default 0.78).
  // stretch: how far the preview may widen the text left to right (1 = never). fill: share of the pill height the
  // letters may use (default 0.7; script fonts have thin, airy strokes so they get more). spacing: letter-spacing in em.
  var FONTS = [
    { id: 'stereo',   label: 'OUI CHEF',  family: '"PE Stereo Gothic", sans-serif', weight: '400', style: 'normal', upper: true, width: 0.78, fill: 0.62 },
    { id: 'andellia', label: 'Andellia',  family: '"PE Andellia", cursive',         weight: '400', style: 'normal', stretch: 1.4, fill: 0.78, width: 0.78 },
    { id: 'angello',  label: 'Angello',   family: '"PE Angello", cursive',          weight: '400', style: 'normal', stretch: 1.4, fill: 0.78, width: 0.78, spacing: -0.03 },
    { id: 'serif',    label: 'DM Serif',  family: '"PE DM Serif", serif',           weight: '400', style: 'normal', width: 0.62, fill: 0.48 },
    { id: 'tokio',    label: 'Tokio',     family: '"PE Tokio", sans-serif',         weight: '400', style: 'normal', width: 0.62, fill: 0.48 },
    { id: 'work',     label: 'Work Sans', family: '"PE Work Sans", sans-serif',     weight: '300', style: 'normal', width: 0.62, fill: 0.48 }
  ];
  function fontById(id) { for (var i = 0; i < FONTS.length; i++) { if (FONTS[i].id === id) { return FONTS[i]; } } return FONTS[0]; }

  /* ---------------- WORD FILTER (same as Team Builder v0.2.3) ---------------- */
  var BLOCKED_ANYWHERE = ['fuck', 'fcuk', 'phuck', 'cunt', 'shit', 'scheiss'];
  var FILTER_EXCEPTIONS = ['scunthorpe', 'shiitake', 'shitake'];
  var BLOCKED_WORDS = ['fuk', 'fck', 'fuq', 'shite', 'wank', 'wanker', 'wankers', 'twat', 'twats', 'slut', 'sluts', 'whore', 'whores', 'pussy', 'asshole', 'arsehole', 'dickhead', 'knobhead', 'bellend', 'bastard', 'bastards', 'nigger', 'nigga', 'faggot', 'fag', 'retard', 'retarded', 'spastic', 'spaz', 'paki', 'chink', 'kike', 'tranny', 'dyke', 'nazi', 'nazis', 'hitler', 'rape', 'rapist', 'porn', 'cum', 'putain', 'pute', 'salope', 'connard', 'connasse', 'encule', 'enculer', 'merde', 'bite', 'nique', 'niquer', 'ntm', 'fdp', 'batard', 'pd', 'scheisse', 'fick', 'ficken', 'ficker', 'fotze', 'arschloch', 'hurensohn', 'hure', 'wichser', 'schlampe', 'mierda', 'puta', 'puto', 'putas', 'joder', 'cono', 'cabron', 'gilipollas', 'polla', 'follar', 'maricon', 'hijoputa', 'chingar', 'chingada', 'pendejo', 'verga', 'cazzo', 'vaffanculo', 'fanculo', 'stronzo', 'stronza', 'puttana', 'troia', 'minchia', 'figa', 'coglione', 'frocio', 'porca'];
  function hasBlockedWord(text) {
    var norm = String(text).toLowerCase().replace(/\u00df/g, 'ss');
    if (norm.normalize) { norm = norm.normalize('NFD').replace(/[\u0300-\u036f]/g, ''); }
    var clean = norm;
    FILTER_EXCEPTIONS.forEach(function (x) { clean = clean.split(x).join(' '); });
    var words = clean.split(/[^a-z]+/).filter(Boolean);
    var spaced = /^([a-z][\s.\-_]+){2,}[a-z]$/.test(clean.trim());
    var targets = spaced ? words.concat([words.join('')]) : words;
    for (var i = 0; i < targets.length; i++) {
      var w = targets[i];
      if (BLOCKED_WORDS.indexOf(w) >= 0) { return true; }
      for (var j = 0; j < BLOCKED_ANYWHERE.length; j++) { if (w.indexOf(BLOCKED_ANYWHERE[j]) >= 0) { return true; } }
    }
    return false;
  }
  // Allowed: Latin letters incl. accents (é, ñ, ø, ł...), numbers, space and simple punctuation
  var ALLOWED = /^[A-Za-z0-9\u00c0-\u00d6\u00d8-\u00f6\u00f8-\u017f .,'\u2019\-:()+?"]*$/;

  function validate(v, max) {
    if (!v) { return { ok: true, blank: true }; }
    if (v.length > max) { return { ok: false, msg: 'Maximum ' + max + ' characters.' }; }
    if (!ALLOWED.test(v)) { return { ok: false, msg: 'Please use letters, numbers and simple punctuation only (no emojis or symbols).' }; }
    if (hasBlockedWord(v)) { return { ok: false, msg: 'We can\u2019t engrave this. Please choose different text.' }; }
    return { ok: true };
  }

  /* ---------------- TEXT FIT (as Kit/Team Builder) ---------------- */
  var _canvas;
  // Returns { px: font size, sx: horizontal stretch, dy: px to move the text so its ink is centred,
  //           lh: line height in px }. Fills targetW wide or targetH tall (ink, not the font box), whichever comes first,
  //           then stretches up to font.stretch if there is still width to spare.
  function fitText(text, font, targetW, targetH) {
    if (!_canvas) { _canvas = document.createElement('canvas'); }
    var ctx = _canvas.getContext('2d'), REF = 100, sp = font.spacing || 0;
    ctx.font = font.style + ' ' + font.weight + ' ' + REF + 'px ' + font.family;
    var m = ctx.measureText(text);
    var w = m.width + sp * REF * Math.max(0, text.length - 1);
    var iA = m.actualBoundingBoxAscent, iD = m.actualBoundingBoxDescent;
    var fA = m.fontBoundingBoxAscent, fD = m.fontBoundingBoxDescent;
    if (!w) { return { px: 14, sx: 1, dy: 0, lh: null }; }
    var inkH = (iA + iD) || REF * 0.7;
    var k = Math.min(targetW / w, targetH / inkH);           // scale from REF
    var sx = Math.max(1, Math.min(font.stretch || 1, targetW / (w * k)));
    var px = Math.max(8, REF * k);
    var f = px / REF, dy = 0, lh = null;
    if (fA && fD && (iA || iD)) {
      lh = (fA + fD) * f;                                   // line box = font box, so the baseline is fA from the top
      dy = ((fD - fA) + (iA - iD)) / 2 * f;                  // move ink centre onto the pill centre
    }
    return { px: px, sx: sx, dy: dy, lh: lh };
  }

  /* ==================================================================
   * v1.3: ONE NAME BOX PER NEEDLE
   * The number of boxes follows the theme's quantity selector. One shared
   * font. On Add to cart each different name becomes its own cart line
   * (Engraving + Font on each line), so the cart, order and packing slip
   * show one name per line and changing a quantity in the cart can never
   * mix names up. Same name twice = one line, quantity 2. Empty boxes =
   * needles with no engraving (one plain line).
   * How: the extra lines are added first with /cart/add.js, then the
   * theme's own Add to cart runs for the first name, so the theme's cart
   * drawer, count and error messages behave exactly as normal.
   * ================================================================== */
  var MAX_BOXES = 50;
  var STORE = {};   // per product form: survives the theme re-rendering the product info on a variant change
  var LIVE = {};    // per product form: the current (connected) engraver

  function liveFor(formId) {
    var api = LIVE[formId];
    return (api && api.root.isConnected) ? api : null;
  }

  // The main product form: Focal names it product-form-main-<product>-<section>
  function findFormId(root) {
    var given = root.getAttribute('data-form-id');
    if (given && document.getElementById(given)) { return given; }
    var f = document.querySelector('form[id^="product-form-main"]') ||
      document.querySelector('form[is="product-form"]') ||
      document.querySelector('form[action*="/cart/add"]');
    return f ? f.getAttribute('id') : '';
  }

  function init(root) {
    if (root.getAttribute('data-pe-ready')) { return; }
    var formId = findFormId(root);
    if (!formId) { return; }                       // form not on the page yet: boot() tries again
    root.setAttribute('data-pe-ready', '1');
    root.setAttribute('data-form-id', formId);
    var propEls = root.querySelectorAll('.pe-prop');
    for (var pi = 0; pi < propEls.length; pi++) { propEls[pi].setAttribute('form', formId); }   // join the theme's form

    var MAX = parseInt(root.getAttribute('data-max-chars'), 10) || 20;
    var PILL = (root.getAttribute('data-pill') || '17.4,78,63.4,17').split(',');   // left, top, width, height (% of photo)
    var SHIFT = parseFloat(root.getAttribute('data-photo-shift')) || 0;   // % of photo height
    var PHOTO_BG = root.getAttribute('data-photo-bg') || '';
    var variants = [];
    try { variants = JSON.parse(root.querySelector('.pe-variants').textContent); } catch (e) {}

    var st = STORE[formId] || (STORE[formId] = { names: [''], fontId: 'stereo', active: 0, variantId: null, pills: [] });
    var list = root.querySelector('.pe-names');
    var errEl = root.querySelector('.pe-error');
    var grid = root.querySelector('.pe-fonts');
    var propText = root.querySelector('.pe-prop-text');
    var propFont = root.querySelector('.pe-prop-font');
    var propType = root.querySelector('.pe-prop-type');

    function form() { return document.getElementById(formId); }
    function qtyInput() {
      return document.querySelector('input[name="quantity"][form="' + formId + '"]') ||
        (form() && form().querySelector('input[name="quantity"]'));
    }
    function qty() { var q = qtyInput(); var n = q ? parseInt(q.value, 10) : 1; return n > 0 ? n : 1; }
    function clean(v) { return String(v || '').replace(/\s+/g, ' ').trim(); }
    function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

    /* ---- name boxes ---- */
    function renderRows() {
      var n = Math.min(qty(), MAX_BOXES);
      var rows = list.querySelectorAll('.pe-row');
      if (rows.length === n) { return; }
      var html = '';
      for (var i = 0; i < n; i++) {
        var val = st.names[i] || '';
        html += '<div class="pe-row" data-i="' + i + '">' +
          '<label class="pe-label" for="pe-text-' + root.id + '-' + i + '">' + (n > 1 ? 'Needle ' + (i + 1) : 'Your engraving') +
          ' <span class="pe-count"><span class="pe-count-n">' + val.length + '</span>/' + MAX + '</span></label>' +
          '<input class="pe-input" id="pe-text-' + root.id + '-' + i + '" data-i="' + i + '" type="text" maxlength="' + MAX + '" autocomplete="off" autocapitalize="off" spellcheck="false" ' +
          'placeholder="' + (i === 0 ? 'e.g. Chef Marco' : 'Name for needle ' + (i + 1) + ' (optional)') + '" value="' + esc(val) + '">' +
          '<p class="pe-row-error" role="alert" hidden></p></div>';
      }
      list.innerHTML = html;
      if (st.active >= n) { st.active = 0; }
      root.classList.toggle('pe--multi', n > 1);
      update();
    }
    list.addEventListener('input', function (e) {
      var i = parseInt(e.target.getAttribute('data-i'), 10);
      if (isNaN(i)) { return; }
      st.names[i] = e.target.value;
      st.active = i;
      var c = e.target.parentNode.querySelector('.pe-count-n');
      if (c) { c.textContent = e.target.value.length; }
      update();
    });
    list.addEventListener('focusin', function (e) {
      var i = parseInt(e.target.getAttribute('data-i'), 10);
      if (!isNaN(i)) { st.active = i; renderPill(); showPillSlide(); }
    });
    list.addEventListener('focusout', function (e) {
      var i = parseInt(e.target.getAttribute('data-i'), 10);
      if (!isNaN(i) && e.target.value !== clean(e.target.value)) { e.target.value = clean(e.target.value); st.names[i] = e.target.value; update(); }
    });
    list.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.classList.contains('pe-input')) {   // Enter = next box, never submits
        e.preventDefault();
        var next = list.querySelector('.pe-input[data-i="' + (parseInt(e.target.getAttribute('data-i'), 10) + 1) + '"]');
        if (next) { next.focus(); }
      }
    });

    /* ---- fonts (one font for all needles) ---- */
    var styleEl = document.createElement('style');
    styleEl.textContent = FONTS.map(function (f) {
      return '#' + root.id + ' .pe-font[data-font-id="' + f.id + '"]{font-family:' + f.family + ' !important;font-weight:' + f.weight + ' !important;font-style:' + f.style + ' !important;' + (f.upper ? 'text-transform:uppercase;' : '') + '}';
    }).join('');
    document.head.appendChild(styleEl);
    grid.innerHTML = FONTS.map(function (f) {
      var on = f.id === st.fontId;
      return '<div class="pe-font' + (on ? ' is-selected' : '') + '" data-font-id="' + f.id + '" role="radio" tabindex="0" aria-checked="' + on + '">' + f.label + '</div>';
    }).join('');
    function forceFontStyles() {
      var bs = grid.querySelectorAll('.pe-font');
      for (var i = 0; i < bs.length; i++) {
        var f = fontById(bs[i].getAttribute('data-font-id'));
        bs[i].style.setProperty('font-family', f.family, 'important');
        bs[i].style.setProperty('font-weight', f.weight, 'important');
        bs[i].style.setProperty('font-style', f.style, 'important');
      }
    }
    forceFontStyles();
    function pickFont(el) {
      if (!el) { return; }
      st.fontId = el.getAttribute('data-font-id');
      showPillSlide();
      var bs = grid.querySelectorAll('.pe-font');
      for (var i = 0; i < bs.length; i++) {
        var on = bs[i] === el;
        bs[i].classList.toggle('is-selected', on);
        bs[i].setAttribute('aria-checked', on ? 'true' : 'false');
      }
      update();
    }
    grid.addEventListener('click', function (e) { pickFont(e.target.closest('.pe-font')); });
    grid.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pickFont(e.target.closest('.pe-font')); }
    });

    /* ---- preview: a pill on each variant's photo in the theme's product gallery ---- */
    var ro = window.ResizeObserver ? new ResizeObserver(function () { renderPill(); }) : null;
    function gallery() { return document.querySelector('product-media[form-id="' + formId + '"]') || document.querySelector('product-media'); }
    function variantById(id) { for (var i = 0; i < variants.length; i++) { if (variants[i].id === id) { return variants[i]; } } return null; }
    function buildPills() {
      st.pills = st.pills.filter(function (p) { return p.el.isConnected; });
      var g = gallery();
      if (!g) { return; }
      var ids = [];
      variants.forEach(function (v) { if (v.media && ids.indexOf(v.media) < 0) { ids.push(v.media); } });
      ids.forEach(function (id) {
        var wrap = g.querySelector('.product__media-item[data-media-id="' + id + '"] .product__media-image-wrapper');
        if (!wrap) { return; }
        var el = wrap.querySelector('.pe-pill');
        var known = st.pills.some(function (p) { return p.el === el; });
        if (el && known) { if (ro) { ro.observe(el); } return; }
        if (!el) {
          if (getComputedStyle(wrap).position === 'static') { wrap.style.position = 'relative'; }
          wrap.classList.add('pe-has-pill');
          if (SHIFT) { wrap.style.setProperty('--pe-shift', (-SHIFT) + '%'); }
          if (PHOTO_BG) { wrap.style.setProperty('--pe-photo-bg', PHOTO_BG); }
          el = document.createElement('div');
          el.className = 'pe-pill';
          el.setAttribute('aria-hidden', 'true');
          el.style.left = PILL[0] + '%'; el.style.top = PILL[1] + '%'; el.style.width = PILL[2] + '%'; el.style.height = PILL[3] + '%';
          el.innerHTML = '<span class="pe-pill-text"></span>';
          wrap.appendChild(el);
        }
        st.pills.push({ el: el, text: el.firstChild, mediaId: id });
        if (ro) { ro.observe(el); }
      });
      colourPills();
      renderPill();
    }
    function colourPills() {
      var cur = variantById(st.variantId);
      st.pills.forEach(function (p) {
        var owner = (cur && (p.follow || cur.media === p.mediaId)) ? cur : null;
        for (var i = 0; !owner && i < variants.length; i++) { if (variants[i].media === p.mediaId) { owner = variants[i]; } }
        var col = colourFor(owner ? owner.title : '');
        p.el.style.background = col.banner;
        if (col.text) { p.el.style.setProperty('--pe-text', col.text); } else { p.el.style.removeProperty('--pe-text'); }
        if (col.shadow) { p.el.style.setProperty('--pe-shadow', col.shadow); } else { p.el.style.removeProperty('--pe-shadow'); }
      });
    }
    function renderPill() {
      var font = fontById(st.fontId);
      var v = clean(st.names[st.active]);
      var empty = !v;
      var useFont = empty ? fontById('work') : font;
      var text = empty ? 'YOUR ENGRAVING' : (font.upper ? v.toUpperCase() : v);
      st.pills.forEach(function (p) {
        var pw = p.el.clientWidth, ph = p.el.clientHeight;
        if (!pw || !ph) { return; }   // hidden slide: done again when it resizes into view
        var fit = fitText(text, useFont, pw * (empty ? 0.62 : (useFont.width || 0.78)), ph * (empty ? 0.3 : (useFont.fill || 0.62)));
        p.text.textContent = text;
        p.text.classList.toggle('is-placeholder', empty);
        p.text.style.cssText = 'font-family:' + useFont.family + ';font-weight:' + useFont.weight + ';font-style:' + useFont.style +
          ';font-size:' + fit.px.toFixed(1) + 'px;' + (fit.lh ? 'line-height:' + fit.lh.toFixed(1) + 'px;' : '') +
          (useFont.spacing ? 'letter-spacing:' + useFont.spacing + 'em;' : '') +
          'transform:translateY(' + fit.dy.toFixed(1) + 'px) scaleX(' + fit.sx.toFixed(3) + ');';
      });
    }
    // Show the photo with the pill for the chosen colour (if the gallery is on another photo)
    /* ---- v1.9: floating preview that follows the customer down the page ---- */
    var floatEl = (st.floatEl && st.floatEl.isConnected) ? st.floatEl : null;   // one per page, kept if the theme re-draws the product info
    if (!floatEl) {
      floatEl = st.floatEl = document.createElement('div');
      floatEl.className = 'pe-float';
      floatEl.setAttribute('aria-hidden', 'true');
      floatEl.innerHTML = '<div class="pe-pill pe-pill--float"><span class="pe-pill-text"></span></div>';
      document.body.appendChild(floatEl);
      st.pills.push({ el: floatEl.firstChild, text: floatEl.firstChild.firstChild, mediaId: null, follow: true });
    }
    if (ro) { ro.observe(floatEl.firstChild); }
    function headerBottom() {
      var h = document.querySelector('store-header, .header, header');
      if (!h) { return 0; }
      var pos = getComputedStyle(h).position, r = h.getBoundingClientRect();
      return ((pos === 'fixed' || pos === 'sticky') && r.bottom > 0) ? r.bottom : 0;
    }
    function inView(el, topEdge) {
      if (!el || !el.isConnected) { return false; }
      var r = el.getBoundingClientRect();
      if (!r.width || !r.height) { return false; }
      return r.bottom > topEdge + r.height * 0.5 && r.top < window.innerHeight - r.height * 0.5;
    }
    function updateFloat() {
      if (!root.isConnected) { return; }   // an older copy of the engraver: the live one handles it
      var hb = headerBottom(), cur = variantById(st.variantId), photoPill = null;
      st.pills.forEach(function (p) { if (!p.follow && cur && p.mediaId === cur.media) { photoPill = p.el; } });
      var slide = photoPill && photoPill.closest('.product__media-item');
      var photoShowing = photoPill && (!slide || slide.classList.contains('is-selected') || !slide.parentNode.querySelector('.is-selected')) && inView(photoPill, hb);
      var r = root.getBoundingClientRect();
      var inEngraver = r.top < window.innerHeight * 0.85 && r.bottom > hb + 60;
      var on = inEngraver && !photoShowing;
      floatEl.style.top = (hb + 10) + 'px';
      if (on !== floatEl.classList.contains('is-on')) { floatEl.classList.toggle('is-on', on); if (on) { colourPills(); renderPill(); } }
    }
    var floatTick = false;
    window.addEventListener('scroll', function () {
      if (floatTick) { return; }
      floatTick = true;
      requestAnimationFrame(function () { floatTick = false; updateFloat(); });
    }, { passive: true });
    window.addEventListener('resize', updateFloat);

    function showPillSlide() {
      var g = gallery(), cur = variantById(st.variantId);
      if (!g || !cur || !cur.media) { return; }
      var sel = g.querySelector('.product__media-item.is-selected');
      if (sel && sel.getAttribute('data-media-id') === String(cur.media)) { return; }
      var btn = g.querySelector('[data-action="select"][data-media-id="' + cur.media + '"]');
      if (btn) { btn.click(); }
    }

    function setVariant(id) {
      id = parseInt(id, 10);
      if (!id || id === st.variantId || !variantById(id)) { return; }
      st.variantId = id;
      colourPills();
    }
    function currentVariantId() {
      var f = form();
      var el = f && f.querySelector('[name="id"]');
      if (el && el.value) { return el.value; }
      var m = /[?&]variant=(\d+)/.exec(location.search);
      return m ? m[1] : (variants[0] && variants[0].id);
    }

    /* ---- validation + the properties the theme's own form sends (first name) ---- */
    function validateAll() {
      var n = Math.min(qty(), MAX_BOXES), firstBad = null;
      var rows = list.querySelectorAll('.pe-row');
      for (var i = 0; i < rows.length; i++) {
        var res = validate(clean(st.names[i]), MAX);
        var inp = rows[i].querySelector('.pe-input'), er = rows[i].querySelector('.pe-row-error');
        inp.classList.toggle('is-invalid', !res.ok);
        er.textContent = res.ok ? '' : res.msg;
        er.hidden = res.ok;
        if (!res.ok && firstBad === null && i < n) { firstBad = i; }
      }
      return firstBad;
    }
    function setFormProps(name) {
      var send = !!name;
      propText.value = send ? name : '';
      propFont.value = send ? fontById(st.fontId).label : '';
      propText.disabled = propFont.disabled = propType.disabled = !send;
    }
    function update() {
      validateAll();
      var first = clean(st.names[0]);
      setFormProps(validate(first, MAX).ok ? first : '');
      renderPill();
    }
    function showError(msg) { errEl.textContent = msg || ''; errEl.hidden = !msg; }

    /* ---- Add to cart: split different names into their own cart lines ---- */
    function groups() {
      var n = qty(), out = [], byName = {};
      for (var i = 0; i < n; i++) {
        var name = i < MAX_BOXES ? clean(st.names[i]) : '';
        if (byName[name] === undefined) { byName[name] = out.length; out.push({ name: name, count: 0 }); }
        out[byName[name]].count++;
      }
      return out;
    }
    function propsFor(name) {
      return name ? { 'Engraving': name, 'Font': fontById(st.fontId).label, '_engraving_type': 'text' } : {};
    }
    function onSubmit(e) {
      var f = e.target;
      if (f.__peGo) { return; }                       // our own hand-over to the theme: let it through
      showError('');
      var bad = validateAll();
      if (bad !== null) {
        e.preventDefault(); e.stopImmediatePropagation();
        var inp = list.querySelector('.pe-input[data-i="' + bad + '"]');
        if (inp) { inp.scrollIntoView({ behavior: 'smooth', block: 'center' }); inp.focus({ preventScroll: true }); }
        return;
      }
      var gs = groups();
      if (gs.length < 2) { setFormProps(gs[0].name); return; }   // all the same: the theme adds it as normal

      e.preventDefault(); e.stopImmediatePropagation();
      var q = qtyInput(), n = qty(), id = parseInt(currentVariantId(), 10);
      var rest = gs.slice(1).map(function (g) { return { id: id, quantity: g.count, properties: propsFor(g.name) }; });
      var btns = document.querySelectorAll('button[type="submit"][form="' + formId + '"], #' + formId + ' button[type="submit"]');
      for (var b = 0; b < btns.length; b++) { btns[b].setAttribute('aria-busy', 'true'); }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
        body: JSON.stringify({ items: rest })
      }).then(function (r) {
        return r.json().then(function (j) { if (!r.ok) { throw j; } return j; });
      }).then(function () {
        for (var b = 0; b < btns.length; b++) { btns[b].removeAttribute('aria-busy'); }
        // The theme now adds the first name with its own Add to cart (drawer, count, messages as normal)
        setFormProps(gs[0].name);
        if (q) { q.value = gs[0].count; }
        var restore = function () {
          document.removeEventListener('variant:added', restore);
          document.removeEventListener('cart-notification:show', restore);
          if (q && parseInt(q.value, 10) !== n) { q.value = n; }
          update();
        };
        document.addEventListener('variant:added', restore);
        document.addEventListener('cart-notification:show', restore);
        setTimeout(restore, 5000);
        f.__peGo = true;
        try { if (f.requestSubmit) { f.requestSubmit(); } else { f.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true })); } }
        finally { f.__peGo = false; }
      }).catch(function (err) {
        for (var b = 0; b < btns.length; b++) { btns[b].removeAttribute('aria-busy'); }
        showError((err && (err.description || err.message)) || 'Sorry, we couldn\u2019t add these to your cart. Please try again.');
      });
    }

    LIVE[formId] = {
      root: root, onSubmit: onSubmit, renderRows: renderRows, setVariant: setVariant,
      buildPills: buildPills, currentVariantId: currentVariantId, renderPill: renderPill, forceFontStyles: forceFontStyles,
      updateFloat: updateFloat
    };

    setVariant(currentVariantId());
    renderRows();
    buildPills();
    // Open on the selected colour's photo (tries for a few seconds while the gallery starts up; stops once done)
    var openTries = 0;
    var openTimer = setInterval(function () {
      openTries++;
      buildPills();
      showPillSlide();
      var g = gallery(), cur = variantById(st.variantId), sel = g && g.querySelector('.product__media-item.is-selected');
      if ((sel && cur && sel.getAttribute('data-media-id') === String(cur.media)) || openTries > 12) { clearInterval(openTimer); }
    }, 300);
    update();
    if (!ro) { window.addEventListener('resize', renderPill); }
    if (document.fonts && document.fonts.ready) { document.fonts.ready.then(function () { renderPill(); forceFontStyles(); }); }
    if (document.fonts && document.fonts.load) {
      FONTS.forEach(function (f) { document.fonts.load(f.style + ' ' + f.weight + ' 20px ' + f.family).then(renderPill, function () {}); });
    }
  }

  /* ---- page-level listeners (once), handed to whichever engraver is live ---- */
  function eachLive(fn) { Object.keys(LIVE).forEach(function (k) { var a = liveFor(k); if (a) { fn(a, k); } }); }

  // Capture phase: runs before the theme's own submit handler. Covers the main button, the sticky bar and Enter.
  document.addEventListener('submit', function (e) {
    var id = e.target && e.target.getAttribute && e.target.getAttribute('id');   // not .id: the form has an input named "id"
    var a = id && liveFor(id);
    if (a) { a.onSubmit(e); }
  }, true);
  document.addEventListener('variant:changed', function (e) {
    var v = e.detail && (e.detail.variant || e.detail);
    eachLive(function (a) { if (v && v.id) { a.setVariant(v.id); } });
  });
  var qtyTimer;
  function onQtyMaybe(e) {
    if (!e.target || e.target.name !== 'quantity') { return; }
    clearTimeout(qtyTimer);
    qtyTimer = setTimeout(function () { eachLive(function (a) { a.renderRows(); }); }, 60);
  }
  document.addEventListener('input', onQtyMaybe);
  document.addEventListener('change', onQtyMaybe);
  document.addEventListener('change', function () { setTimeout(function () { eachLive(function (a) { a.setVariant(a.currentVariantId()); }); }, 30); });

  function boot() { var els = document.querySelectorAll('.pe:not([data-pe-ready])'); for (var i = 0; i < els.length; i++) { init(els[i]); } }
  // Safety net: catches a re-rendered product info block, a missed quantity or variant change, and gallery changes
  setInterval(function () {
    boot();
    eachLive(function (a) { a.setVariant(a.currentVariantId()); a.renderRows(); a.buildPills(); a.updateFloat(); });
  }, 500);
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
